import { ListProvider } from "./list-provider";
import { LookupType } from "../../../../business-objects/lookup-type/lookup-type.model";
import { LookupTypeStoreFacade } from "../../../../business-objects/lookup-type/lookup-type.store-facade";

export class LookupTypeListProvider extends ListProvider<LookupType> {

    getFacade(): LookupTypeStoreFacade {
        return this.appFacade.objects.lookupType.store;
    }

    getPrimaryField(item: LookupType): string {
        return item && item.title;
    }

    getSecondaryField(item: LookupType): string {
        return item && item.title;
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/form/list-providers/lookup-type-list-provider.ts